import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text, Button } from '@rsos/base-components';

const FetchErrorComponent = ({ handleFetchAlertTypes }) => {
  return (
    <Box height={150}>
      <Box justify="space-between" horizontal align="center" mx="5px">
        <Box horizontal flow={5} color="heavyWarning">
          <AttentionTriangleIcon width={12} height={12} />
          <Text size="small">There was an error</Text>
        </Box>
        <Button
          btnType="tertiary"
          size="small"
          onClick={handleFetchAlertTypes}
          dataName="retry-fetch-alert-types"
        >
          Try again
        </Button>
      </Box>
    </Box>
  );
};

export default FetchErrorComponent;
